<!-- service provider details -->

<div
	*ngIf="data.serviceProvider"
	class="bg-white rounded-[12px] px-[36px] py-[46px] max-mobile:py-[7px] max-mobile:px-[12px]"
>
	<div class="flex justify-between mb-[24px]">
		<p class="text-[18px] text-[#4E4B66] font-DIN-bold font-bold">
			{{ 'PAYOUT.PAYOUT_LIST.TRANSACTION' | translate }}
		</p>
		<div (click)="closeDialog()">
			<img
				class="ml-[100%] cursor-pointer"
				src="assets/images/close-square.svg"
				alt=""
			/>
		</div>
	</div>
	<div class="lg:flex justify-between gap-5">
		<div class="w-full">
			<div class="w-full bg-grey-background rounded-[12px] p-[8x] h-fit">
				<div
					class="py-[8px] px-[24px] flex gap-[8px] rounded-t-[12px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_NUMBER' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							#{{ payoutSpDetails?.payoutNumber }}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/user.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.SERVICEPROVIDER_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutSpDetails?.organizationName }}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/user.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.BRANCH_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutSpDetails?.branchName }}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/calendar.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.REQUEST_DATE' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								payoutSpDetails?.requestDate
									| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
							}}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/calendar.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.PAY_DATE' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								payoutSpDetails?.actionDate
									| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
							}}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/bank.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_METHOD' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								translate.currentLang === 'ar'
									? payoutSpDetails?.payoutMethod?.nameAr
									: payoutSpDetails?.payoutMethod?.nameEn
							}}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/dollar-circle.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.AMOUNT' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutSpDetails?.requestedAmount }}
							{{
								translate.currentLang === 'ar'
									? payoutSpDetails.currency?.name?.ar
									: payoutSpDetails.currency?.name?.en
							}}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutSpDetails?.payoutMethod?.id == 1"
					class="py-[8px] px-[24px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/bank.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.BANK_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
							{{ payoutSpDetails?.bankName }}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutSpDetails?.payoutMethod?.id == 1"
					class="py-[8px] px-[24px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.ACC_NUMBER' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
							{{ payoutSpDetails?.accountNumber }}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutSpDetails?.payoutMethod?.id == 1"
					class="py-[8px] px-[24px] rounded-[12px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/bank.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.ACC_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutSpDetails?.accountName }}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutSpDetails?.payoutMethod?.id == 2"
					class="py-[8px] px-[24px] rounded-[12px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.FAWRY_ACC_NUMBER' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutSpDetails?.fawryAccount }}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutSpDetails?.payoutMethod?.id == 3"
					class="py-[8px] px-[24px] rounded-[12px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.INSTA_ID' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutSpDetails?.instapayAccount }}
						</p>
					</div>
				</div>
			</div>
			<div
				*ngIf="payoutSpDetails?.notes != null || payoutSpDetails?.notes != ''"
				class="mt-[24px]"
			>
				<p class="text-[#4E4B66] text-[16px] mb-0">
					{{ 'PAYOUT.PAYOUT_LIST.NOTES' | translate }}
				</p>
				<p class="text-[#6E7191] text-[14px] mb-0">
					{{ payoutSpDetails?.notes }}
				</p>
			</div>
		</div>
		<img
			[src]="
				payoutSpDetails?.attachmentUrl == '' ||
				payoutSpDetails?.attachmentUrl == null
					? 'assets/images/empty.svg'
					: imgPath + payoutSpDetails?.attachmentUrl
			"
			class="h-[530px] max-w-[300px] rounded-[12px]"
			alt=""
			srcset=""
		/>
	</div>
</div>

<!-- client details -->

<div
	*ngIf="data.client"
	class="bg-white rounded-[12px] px-[36px] py-[46px] max-mobile:py-[7px] max-mobile:px-[12px]"
>
	<div class="flex justify-between mb-[24px]">
		<p class="text-[18px] text-[#4E4B66] font-DIN-bold font-bold">
			{{ 'PAYOUT.PAYOUT_LIST.TRANSACTION' | translate }}
		</p>
		<div (click)="closeDialog()">
			<img
				class="ml-[100%] cursor-pointer"
				src="assets/images/close-square.svg"
				alt=""
			/>
		</div>
	</div>
	<div class="lg:flex justify-between gap-5">
		<div class="w-full">
			<div class="w-full bg-grey-background rounded-[12px] p-[8x] h-fit">
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray w-full"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_NUMBER' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							#{{ payoutClientDetails?.payoutNumber }}
						</p>
					</div>
				</div>

				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/user.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.CLIENT_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutClientDetails?.clientName }}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/calendar.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.REQUEST_DATE' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								payoutClientDetails?.requestDate
									| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
							}}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutClientDetails?.payoutStatus == 2"
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/calendar.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.PAY_DATE' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								payoutClientDetails?.actionDate
									| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
							}}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutClientDetails?.payoutStatus == 3"
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="my-auto"
						src="./assets/images/calendar-tick.svg"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.CANCELLED_DATE' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								payoutClientDetails?.actionDate
									| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
							}}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/bank.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_METHOD' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{
								translate.currentLang === 'ar'
									? payoutClientDetails?.payoutMethod?.nameAr
									: payoutClientDetails?.payoutMethod?.nameEn
							}}
						</p>
					</div>
				</div>
				<div
					class="py-[8px] px-[24px] flex gap-[8px] border-b-[1px] border-secondry-color-Gray bg-grey-background w-full"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/dollar-circle.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.REQUEST_AMOUNT' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutClientDetails?.requestedAmount }}
							{{
								translate.currentLang === 'ar'
									? payoutClientDetails.currency?.name?.ar
									: payoutClientDetails.currency?.name?.en
							}}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutClientDetails?.payoutMethod?.id == 1"
					class="py-[8px] px-[24px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/bank.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.BANK_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
							{{ payoutClientDetails?.bankName }}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutClientDetails?.payoutMethod?.id == 1"
					class="py-[8px] px-[24px] flex gap-[8px] w-full border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<img
						class="my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.ACC_NUMBER' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
							{{ payoutClientDetails?.accountNumber }}
						</p>
					</div>
				</div>
				<div
					*ngIf="payoutClientDetails?.payoutMethod?.id == 1"
					class="py-[8px] px-[24px] flex gap-[8px] rounded-[12px] w-full bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/bank.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.ACC_NAME' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutClientDetails?.accountName }}
						</p>
					</div>
				</div>

				<div
					*ngIf="payoutClientDetails?.payoutMethod?.id == 2"
					class="py-[8px] px-[24px] flex gap-[8px] rounded-[12px] w-full bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.FAWRY_ACC_NUMBER' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutClientDetails?.fawryAccount }}
						</p>
					</div>
				</div>

				<div
					*ngIf="payoutClientDetails?.payoutMethod?.id == 3"
					class="py-[8px] px-[24px] flex gap-[8px] rounded-[12px] w-full bg-grey-background"
				>
					<img
						class="h-[24px] w-[24px] my-auto"
						src="./assets/images/receipt-2.png"
						alt=""
						srcset=""
					/>

					<div>
						<p class="text-[#6E7191] text-[12px] mb-0">
							{{ 'PAYOUT.PAYOUT_LIST.INSTA_ID' | translate }}
						</p>
						<p class="text-[#4E4B66] text-[16px] mb-0">
							{{ payoutClientDetails?.instapayAccount }}
						</p>
					</div>
				</div>
			</div>
			<div *ngIf="payoutClientDetails?.notes != null" class="mt-[24px]">
				<p class="text-[#4E4B66] text-[16px] mb-0">
					{{ 'PAYOUT.PAYOUT_LIST.NOTES' | translate }}
				</p>
				<p class="text-[#6E7191] text-[14px] mb-0">
					{{ payoutClientDetails?.notes }}
				</p>
			</div>
		</div>
		<img
			*ngIf="payoutClientDetails?.payoutStatus == 2"
			[src]="
				payoutClientDetails?.attachmentUrl == '' ||
				payoutClientDetails?.attachmentUrl == null
					? 'assets/images/empty.svg'
					: imgPath + payoutClientDetails?.attachmentUrl
			"
			class="h-[530px] max-w-[340px] rounded-[12px]"
			alt=""
			srcset=""
		/>
	</div>
</div>
